import { createStore } from 'vuex';



const store = createStore({
    state:{
        lang: 'it',
        userIsLoggedIn: false,
        userData: null,
        erroreGenericoApplicazione: false
    },
    mutations:{
      changeLanguage(state,lang){
        switch(lang){
          case 'it':
          case 'en':
            state.lang = lang;
        }
      },
      showErroreGenerico(state){
        state.erroreGenericoApplicazione = true;
      },
      hideErroreGenerico(state){
        state.erroreGenericoApplicazione = false;
      },
      login(state){
        state.userIsLoggedIn = true;
      },
      logout(state){
        state.userIsLoggedIn = false;
        state.userData = null;
      },
      setUserData(state,userData){
        state.userData = userData
      }
      
    },
    actions:{
      CHECK_USER_ALREADY_LOGGED({commit,dispatch}) {
        if (localStorage.getItem(process.env.VUE_APP_TOKEN_ID) && localStorage.getItem("last_user_id")) {
          commit("login")
        }
      },
      
       
    },
    getters:{

    },
    modules:{
      
    },


})
  export default store;
